import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  overflow: hidden;
  border: 1px solid ${Colors.Neutral15};
  cursor: pointer;
  justify-content: space-between;
  flex-direction: column;
  border-radius: ${Spacing['2XS']};
  background-color: ${Colors.Neutral10};
`

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 2px 2px 0 2px;
  padding: 20px;

  ${Media.Phone`
    padding: 16px;
  `}
`

export const TextContainer = styled.div`
  display: flex;
  margin-top: ${Spacing['2XS']};
  gap: ${Spacing['3XS']};
  flex-direction: column;
`

export const IconContainer = styled.div``
export const Header = styled.h2`
  color: ${Colors.Neutral90};

  ${Typography.Subhead}
  ${FontWeights.Medium}
`

export const Description = styled.p`
  color: ${Colors.Neutral50};

  ${Typography.Body}
  ${FontWeights.Regular}
`

export const SecondLine = styled.div`
  display: flex;
  background-color: ${Colors.White};
  padding: 20px;
  justify-content: space-between;
  margin: 0 2px;
  border-radius: ${Spacing['2XS']};
  ${Media.Phone`
    padding: 16px;
  `}
`
export const SecondLineTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ResumeTailoringText = styled.div`
  color: ${Colors.Neutral90};

  ${Typography.Body}
  ${FontWeights.Medium}

  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`
export const Status = styled.div`
  color: ${Colors.Neutral50};

  ${Typography.Body}
  ${FontWeights.Regular}
`

export const StatusIcon = styled.div<{ $enabled: boolean }>`
  margin-left: 6px;
  width: 8px;
  height: 8px;
  background-color: ${({ $enabled }) => ($enabled ? Colors.Green40 : Colors.Amber40)};
  display: inline-block;
  border-radius: 50%;
`

export const WrapperToggle = styled.div`
  & div {
    margin: 0;
  }
`
